const context = {
  context: {},
};

export default context;



// WEBPACK FOOTER //
// ./src/app/utils/Context/Context.js